<template>
  <generic-modal :title="$t('details')" ref="generic_modal">
    <!-- <div class="title is-5" v-if="request.profile">
      {{ $t("profile") }} {{ request.profile.name }}
    </div>
    <div class="subtitle is-6">
      {{ format_date_time(request.create_date) }} -
      {{ translate_status(request.status_code) }}
    </div> -->
    <div v-if="request && request.settings">
      <!-- <div class="title is-5">
        {{ $t("data to search") }}
      </div>
      <div class="subtitle is-6">
        {{ format_date_time(request.request_date) }}
      </div>
      <div class="columns">
        <div class="column">
          <div class="title is-6">{{ $t("dpi") }}</div>
          <div class="subtitle is-6">{{ request.settings.dpi }}</div>
        </div>
        <div class="column">
          <div class="title is-6">{{ $t("first name") }}</div>
          <div class="subtitle is-6">{{ request.settings.first_name }}</div>
        </div>
        <div class="column">
          <div class="title is-6">{{ $t("first surname") }}</div>
          <div class="subtitle is-6">{{ request.settings.first_surname }}</div>
        </div>
      </div>

      <div class="title is-5">{{ $t("result") }}</div>
      <div class="subtitle is-6">
        {{ format_date_time(request.response_date) }}
      </div> -->
      <div class="container">
        <article
          class="message is-warning"
          v-if="request.response_data.result == false"
        >
          <div class="message-header">
            <p>{{ request.response_data.responseCode }}</p>
          </div>
          <div class="message-body">
            {{ request.response_data.mensaje }}
          </div>
        </article>
        <div v-else>
          <div class="columns">
            <div class="column is-4">
              <img
                :src="`data:image/jpeg;base64,${request.response_data.data.FOTO}`"
                class="image"
                v-if="request.response_data.data.FOTO"
                alt="Foto"
              />
            </div>
            <div class="column">
              <p class="title is-5">
                {{
                  `${request.response_data.data.PRIMER_NOMBRE} ${request.response_data.data.SEGUNDO_NOMBRE} ${request.response_data.data.PRIMER_APELLIDO} ${request.response_data.data.SEGUNDO_APELLIDO}`
                }}
              </p>
              <p class="subtitle is-6">
                CUI: {{ request.response_data.data.CUI }}
              </p>

              <div class="field">
                <div class="control">
                  <generic-uploader
                    ref="generic_uploader"
                    :idle_label="$t('drop customer photo here to compare')"
                    endpoint_url="/renap/request/upload-compare"
                    :extra_data="{ uuid: request.uuid }"
                    :allow_multiple="false"
                    @error="error_uploading"
                    @success="success_uploading"
                  />
                </div>
              </div>
              <div class="content">
                <pre>{{ comparisson_result }}</pre>
              </div>
            </div>
          </div>
          <div class="columns is-multiline">
            <div class="column is-half">
              <span class="info-label">Fecha de Nacimiento:</span>
              {{ request.response_data.data.FECHA_NACIMIENTO }}
            </div>
            <div class="column is-half">
              <span class="info-label">Género:</span>
              {{
                request.response_data.data.GENERO == "M"
                  ? $t("masculine")
                  : $t("feminine")
              }}
            </div>
            <div class="column is-half">
              <span class="info-label">Estado Civil:</span>
              {{
                request.response_data.data.ESTADO_CIVIL == "S"
                  ? $t("single")
                  : request.response_data.data.ESTADO_CIVIL == "C"
                  ? $t("married")
                  : request.response_data.data.ESTADO_CIVIL == "D"
                  ? $t("divorced")
                  : request.response_data.data.ESTADO_CIVIL == "V"
                  ? $t("widowed")
                  : request.response_data.data.ESTADO_CIVIL
              }}
            </div>
            <div class="column is-half">
              <span class="info-label">Ocupación:</span>
              {{ request.response_data.data.OCUPACION }}
            </div>
            <div class="column is-half">
              <span class="info-label">Nacionalidad:</span>
              {{ request.response_data.data.NACIONALIDAD }}
            </div>
            <div class="column is-half">
              <span class="info-label">País de Nacimiento:</span>
              {{ request.response_data.data.PAIS_NACIMIENTO }}
            </div>
            <div class="column is-half">
              <span class="info-label">Orden Cédula:</span>
              {{ request.response_data.data.ORDEN_CEDULA }}
            </div>
            <div class="column is-half">
              <span class="info-label">Registro Cédula:</span>
              {{ request.response_data.data.REGISTRO_CEDULA }}
            </div>
            <div class="column is-half">
              <span class="info-label">Correlativo DPI:</span>
              {{ request.response_data.data.CORRELATIVO_DPI }}
            </div>
            <div class="column is-half">
              <span class="info-label">Fecha de Vencimiento:</span>
              {{ request.response_data.data.FECHA_VENCIMIENTO }}
            </div>
            <div class="column is-half">
              <span class="info-label">Vecindad:</span>
              {{ request.response_data.data.VECINDAD }}
            </div>
            <div class="column is-half">
              <span class="info-label">Nacimiento:</span>
              {{ request.response_data.data.PAIS_NACIMIENTO }},
              {{ request.response_data.data.DEPTO_NACIMIENTO }},
              {{ request.response_data.data.MUNI_NACIMIENTO }}
            </div>
          </div>
          <!-- <pre>{{ request.response_data.data }}</pre> -->
        </div>
      </div>
    </div>

    <!-- <pre>{{ request }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  post,
  change_active_tab,
  generate_error_message_text,
  get,
  format_date_time,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";

export default {
  name: "OnfidoRequestDetailModal",
  components: { GenericModal, GenericUploader },
  props: {},
  data() {
    return {
      request: {},
      error: "",
      comparisson_result: {},
    };
  },
  computed: {},
  methods: {
    change_active_tab: change_active_tab,
    format_date_time,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
      v.$root.loader(true);
      get("/renap/request", { uuid: uuid })
        .then((res) => {
          if (res && res.response_data && res.response_data.data)
            res.response_data.data = res.response_data.data.find((x) => x);
          v.request = res;
        })
        .catch((err) => {
          v.error = generate_error_message_text(err);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    set_initial_state() {
      let v = this;
      v.request = {};
      v.error = "";
      v.comparisson_result = {};
      if (v.$refs.generic_uploader) v.$refs.generic_uploader.clear();
    },
    translate_status(status) {
      let v = this;
      switch (status) {
        case "C":
          return v.$t("created");
        case "E":
          return v.$t("errored");
        case "T":
          return v.$t("token retrieved");
        case "D":
          return v.$t("data retrieved");
        default:
          return status;
      }
    },
    error_uploading(error) {
      console.error(error);
    },
    success_uploading(response) {
      let v = this;
      let r = JSON.parse(response.serverId);
      v.comparisson_result = r;
      // v.$refs.generic_uploader.clear();
      // let rspnse = JSON.parse(response.serverId);
      // let data = {
      //   final_name: rspnse.final_name,
      //   filepath: rspnse.filepath,
      // };
      // v.meta.photo = data;
    },
  },
  mounted() {},
  created() {},
  watch: {},
};
</script>
<style></style>
